import React from 'react';

const PickupCancellationComponentLoadable = React.lazy(() => import('./PickupCancellationComponent'));


export {
  PickupCancellationComponentLoadable
};
